var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmittalSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.793,
    height: 11.176,
    viewBox: "0 0 8.793 11.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8079",
    "data-name": "Path 8079",
    d: "M12.443,8.6V7.215a1.787,1.787,0,0,0-1.787-1.787H9.862a.6.6,0,0,1-.6-.6V4.037A1.787,1.787,0,0,0,7.479,2.25H6.486M6.486,9h3.972M6.486,10.591H8.472M7.677,2.25H5.1a.6.6,0,0,0-.6.6v9.135a.6.6,0,0,0,.6.6h6.752a.6.6,0,0,0,.6-.6V7.016A4.766,4.766,0,0,0,7.677,2.25Z",
    transform: "translate(-4.075 -1.825)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittalSm);
export default __webpack_public_path__ + "static/media/submittal-sm.1db70df79881ec65a1012560ea6f82a2.svg";
export { ForwardRef as ReactComponent };